export function newlinesToHtmlBR(stringToUnify: string): string {
  return stringToUnify.replaceAll(/(\r\n|\n|\r)/gm, '<br />')
}
